<template>
  <responsive-modal v-model="dialog" :size="size">
    <div
      class="d-flex flex-column text-center justify-content-center align-items-center p-5 modal-completed"
    >
      <div class="completed-icon mb-9 mt-5">
        <i class="icon-check"></i>
        <img src="@/assets/images/stars.svg" class="image-stars" />
      </div>

      <span class="font-weight-bold">{{ title }}</span>
      <small class="mb-9 text-muted">{{ description }} </small>
      <button
        type="button"
        class="btn btn-fixed-size btn-primary px-5"
        @click="confirm"
      >
        {{ btnText }}
      </button>
    </div>
  </responsive-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Concluído"
    },
    description: {
      type: String,
      default: "Seu produto foi cadastrado com sucesso!"
    },
    btnText: {
      type: String,
      default: "Fechar"
    },
    size: {
      type: String,
      default: "sm"
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    confirm() {
      this.$emit("action");
      this.$emit("refresh");
    }
  },
  watch: {
    dialog(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.dialog = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-completed {
}
</style>
